const gcWestNileBasicQuizz = [
    {
        question: 'O que é um vírus?',
        correct_answer: 'Um agente infeccioso que se replica dentro de células de um organismo',
        incorrect_answers:
            [
                'Um organismo multicelular que se desenvolve nos seres humanos',
                'Um organismo unicelular que se desenvolve nos seres humanos',
                'Um agente infeccioso inofensivo que não consegue atingir seres vivos'
            ]
    },
    {
        question: 'O que é o vírus do Nilo Ocidental?',
        correct_answer: 'A doença é uma infecção viral que pode ser assintomática ou com sintomas de distintos graus de gravidade',
        incorrect_answers:
            [
                'É uma doença que pertence ao grupo dos coronavírus',
                'Caracteriza-se por ser uma doença que tem sempre vários sintomas nos seus infetados',
                'É um vírus já extinto, antes presente em Portugal e outros países da região da Europa'
            ]
    },
    {
        question: 'Como é transmitido o vírus do Nilo Ocidental?',
        correct_answer: 'É transmitido pela picada de um vetor infetado, como algumas espécies de mosquitos',
        incorrect_answers:
            [
                'É transmitido pelo contacto humano, pelo toque',
                'Não se sabe os meios de transmissão para este vírus',
                'Pode ser transmitido através do ar, através de micropartículas'
            ]
    },
    {
        question: 'Qual é o tratamento para o vírus do Nilo Ociedental?',
        correct_answer: 'Não existe vacina ou tratamento antiviral específico para a Febre do Nilo Ocidental',
        incorrect_answers:
            [
                'O tratamento mais recomendado é a vacina',
                'Para tratar este vírus é necessário cuidado médico intensivo na maioria dos casos',
                'É possível tratar este vírus à base de um novo medicamento desenvolvido em Portugal'
            ]
    },
]

export {
    gcWestNileBasicQuizz
}